import { formatFileSize } from "../utils";
import { ReactComponent as DownloadIcon } from "../assets/images/icons/ic-download.svg";
import { ReactComponent as CloseIcon } from "../assets/images/icons/ic-close.svg";
import styles from "./MaterialButton.module.css";
import { useCallback, useMemo } from "react";
import ThumbnailPdf from "../assets/images/illustrations/il-thumbnail-pdf.svg"
import ThumbnailPpt from "../assets/images/illustrations/il-thumbnail-ppt.svg"
import ThumbnailVideo from "../assets/images/illustrations/il-thumbnail-video.svg"
import ThumbnailExcel from "../assets/images/illustrations/il-thumbnail-excel.svg"
import ThumbnailText from "../assets/images/illustrations/il-thumbnail-text.svg"
import ThumbnailGeneric from "../assets/images/illustrations/il-thumbnail-generic.svg"
import ThumbnailImage from "../assets/images/illustrations/il-thumbnail-image.svg"

  const imagesExtensions = ["jpg", "jpeg", "png", "svg", "webp", "gif", "avif", "apng", "heic"]
  const videoExtensions = ["mp4", "m4p", "mov", "flv", "mkv", "avi", "wmv", "mpg", "mpeg", "m2v"]
  const pptExtensions = ["ppt", "pptx"]
  const excelExtensions = ["xlsx", "xls"]
  const textExtensions = ["docx", "doc"]

const MaterialButton = ({ material, modern = false, lesson = false, thumbnail = false, downloadable = false, onClick = () => { }, style = {} }) => {

  const onDownload = useCallback(() => {
    const link = document.createElement("a");
    link.href = material.url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, [material]);

  const Thumbnail = useMemo(() => {
    if (material) {
      const split = (material.name || "").split(".")
      const fileExtension = split.length > 1 ? split[split.length - 1].toLowerCase() : ""
      if (videoExtensions.includes(fileExtension)) {
        return ThumbnailVideo
      }
      if (imagesExtensions.includes(fileExtension)) {
        return ThumbnailImage
      }
      if (pptExtensions.includes(fileExtension)) {
        return ThumbnailPpt
      }
      if (excelExtensions.includes(fileExtension)) {
        return ThumbnailExcel
      }
      if (textExtensions.includes(fileExtension)) {
        return ThumbnailText
      }
      if (fileExtension === "pdf") {
        return ThumbnailPdf
      }
    }
    return ThumbnailGeneric
  }, [material])

  return (
    <div className={`${styles.material} ${modern ? styles.modern : ""}`} style={style}>
      <div className={styles.fileDetails} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0.5rem'}}>
        {thumbnail &&
          <img src={Thumbnail} className={styles.thumbnail} alt="" />
        }
        <div className={styles.info}>
          <div className={styles.name} title={material.name}>{material.name}</div>
          <div className={styles.size}>{modern && <span>{material.name?.split(".").length > 1 ? (material.name || "").split(".").pop().toUpperCase() : "FILE"} · </span>}{formatFileSize(material.size)}</div>
          {lesson && material.lesson &&
            <a target="_blank" rel="noreferrer" href={`/lessons/${material.lesson.room_name}`} className={styles.lesson}>{material.lesson?.name}</a>
          }
        </div>
      </div>
      {
        downloadable &&
        <button type="button" aria-label={`Scarica ${material.name}`} className={styles.download} onClick={(e) => {
          e.stopPropagation()
          onDownload()
          }}>
          <DownloadIcon />{modern && <span>Scarica</span>}
        </button>
      }
      {
        !downloadable &&
        <button type="button" aria-label={`Rimuovi ${material.name}`} className={styles.close} onClick={onClick}>
          <CloseIcon />
        </button>
      }
    </div>
  );
};

export default MaterialButton;
